import { projectRequest } from 'store/utils/request';

export const startChatRequest = async data => {
  try {
    return await projectRequest.post(`/reload_chat/`, data, {
      timeout: 60000,
    });
  } catch (error) {
    throw error;
  }
};

export const sendMessageRequest = async data => {
  try {
    return await projectRequest.post(`/chat/`, data);
  } catch (error) {
    throw error;
  }
};
